import { render } from "./TvmFlowEndLink.vue?vue&type=template&id=052cd9a0&scoped=true"
import script from "./TvmFlowEndLink.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndLink.vue?vue&type=script&lang=js"

import "./TvmFlowEndLink.vue?vue&type=style&index=0&id=052cd9a0&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052cd9a0"],['__file',"src/components/ChatWidget/TvmFlowEndItems/TvmFlowEndLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "052cd9a0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('052cd9a0', __exports__)) {
    api.reload('052cd9a0', __exports__)
  }
  
  module.hot.accept("./TvmFlowEndLink.vue?vue&type=template&id=052cd9a0&scoped=true", () => {
    api.rerender('052cd9a0', render)
  })

}


export default __exports__